import { render, staticRenderFns } from "./SlotFloor.vue?vue&type=template&id=5c20fbf4&"
import script from "./SlotFloor.vue?vue&type=script&lang=js&"
export * from "./SlotFloor.vue?vue&type=script&lang=js&"
import style0 from "./SlotFloor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports